import { LogisticFeature } from '../../../../types/catalog';

function LogisticFeatureTable({ features }: { features: LogisticFeature[] }) {
    return (
        <div className="product-table__wrapper">
            <div className="table-wrapper">
                <table className="table table--border">
                    <thead>
                        <tr>
                            <th />
                            <th>Индивидуальная</th>
                            <th>Групповая</th>
                            <th>Транспортная</th>
                        </tr>
                    </thead>
                    <tbody>
                        {features.map(({ name, value, unit }, idx) => (
                            <tr key={idx}>
                                <td>{name}</td>
                                {Object.values(value).map((value, idx) => (
                                    <td key={idx}>
                                        {value} {unit}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default LogisticFeatureTable;
